// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"86":"auth-module","601":"catalog-module","625":"gaming-module","683":"notices-module","723":"core-module","837":"account-module"}[chunkId] + "." + {"86":"a34ff399","601":"c3b0d745","625":"337daf4d","683":"2f39c7c4","723":"47592d56","837":"2cc5ae70"}[chunkId] + ".css";
};